@if (icon()) {
  <span class="ntt-nav-item__icon">
    <ng-content select="[nttNavItemIcon]" />
  </span>
}
<span class="ntt-nav-item__label">
  <ng-content />
</span>
